// src/components/navigation/Navigation.jsx
// import { useState } from 'react';

// DYNAMIC MENU IMPORT
import { useState, useLayoutEffect, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useGetMenuMaster, useGetMenu } from 'api/menu';

import useMediaQuery from '@mui/material/useMediaQuery';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

// project imports
import NavItem from './NavItem';
import NavGroup from './NavGroup';
// import menuItems from 'menu-items';

import useConfig from 'hooks/useConfig';
import { HORIZONTAL_MAX_ITEM, MenuOrientation } from 'config';
// import { useGetMenuMaster } from 'api/menu';

// ==============================|| DRAWER CONTENT - NAVIGATION ||============================== //

//=========================================================
//              FUNCTION MENU DYNAMIC                  =
//=========================================================
function getParentPathForHiddenRoute(path) {
  const p = String(path || '')
    .replace(/^\/+|\/+$/g, '')
    .toLowerCase();
  if (p === 'history-download-video' || p === 'history-video') return 'live-streaming';
  if (p === 'dashboard' || p === 'dashboard') return 'dashboard-vehicle';
  return p;
}

function recursiveFind(nodes = [], matchPath = '', matchName = '') {
  if (!nodes || !nodes.length) return null;

  const target = getParentPathForHiddenRoute(matchPath);
  const rawName = String(matchName || '').toLowerCase();
  const name = getParentPathForHiddenRoute(rawName);

  let bestMatch = null;
  let bestMatchLength = -1;

  const walk = (list, ancestors = []) => {
    for (const node of list) {
      // node mungkin group -> memiliki children array
      const rawUrl = node.url || node.link || '';
      const urlVal = rawUrl
        ? String(rawUrl)
            .replace(/^\/+|\/+$/g, '')
            .toLowerCase()
        : '';
      const idVal = String(node.id || '').toLowerCase();

      // Check for exact match
      if (urlVal && urlVal === target) {
        return { node, ancestors, level: ancestors.length + 1 };
      }

      // If node.id or last segment equals query name
      const lastSegment = (urlVal && urlVal.split('/').filter(Boolean).pop()) || idVal.split('/').pop();
      if (name && (lastSegment === name || idVal === name || node.title?.toLowerCase() === name)) {
        return { node, ancestors, level: ancestors.length + 1 };
      }

      // Check if target is a sub-path of urlVal (e.g. target="live-streaming/history", urlVal="live-streaming")
      if (urlVal && target.startsWith(urlVal + '/')) {
        if (urlVal.length > bestMatchLength) {
          bestMatch = { node, ancestors, level: ancestors.length + 1 };
          bestMatchLength = urlVal.length;
        }
      }

      // heuristik 3: endsWith (fallback)
      if (urlVal && target.endsWith(urlVal)) {
        if (urlVal.length > bestMatchLength) {
          bestMatch = { node, ancestors, level: ancestors.length + 1 };
          bestMatchLength = urlVal.length;
        }
      }

      // if node has children, walk deeper
      if (Array.isArray(node.children) && node.children.length) {
        const found = walk(node.children, [...ancestors, node]);
        if (found) return found; // exact match in children
      }
    }
    return null;
  };

  const exactMatch = walk(nodes, []);
  return exactMatch || bestMatch;
}

export default function Navigation() {
  const { menuOrientation } = useConfig();
  const { menuMaster } = useGetMenuMaster();
  const drawerOpen = menuMaster.isDashboardDrawerOpened;
  const downLG = useMediaQuery((theme) => theme.breakpoints.down('lg'));
  const [selectedID, setSelectedID] = useState('');
  const [selectedItems, setSelectedItems] = useState('');
  const [selectedLevel, setSelectedLevel] = useState(0);

  //=========================================================
  //              EFECT UNTUK MENU DYNAMIC                  =
  //=========================================================
  const location = useLocation();
  const { menu, menuLoading } = useGetMenu();
  const [menuItems, setMenuItems] = useState({ items: [] });
  useLayoutEffect(() => {
    if (!menuLoading && menu) {
      setMenuItems({ items: menu });
    }
  }, [menu, menuLoading]);

  useEffect(() => {
    const path = location.pathname.replace(/^\/+|\/+$/g, '');
    const qs = new URLSearchParams(location.search);
    const nameFromQuery = qs.get('name') || '';

    // cari di menuItems.items
    const groups = menuItems.items || [];
    const found = recursiveFind(groups, path, nameFromQuery);

    if (found && found.node) {
      setSelectedID(found.node.id ?? found.node.title ?? '');
      setSelectedItems(found.ancestors ?? '');
      setSelectedLevel(found.level ?? 0);
    } else {
      setSelectedID('');
      setSelectedItems('');
      setSelectedLevel(0);
    }
  }, [location, menuItems]);

  const isHorizontal = menuOrientation === MenuOrientation.HORIZONTAL && !downLG;

  const lastItem = isHorizontal ? HORIZONTAL_MAX_ITEM : null;
  let lastItemIndex = menuItems.items.length - 1;
  let remItems = [];
  let lastItemId;

  if (lastItem && lastItem < menuItems.items.length) {
    lastItemId = menuItems.items[lastItem - 1].id;
    lastItemIndex = lastItem - 1;
    remItems = menuItems.items.slice(lastItem - 1, menuItems.items.length).map((item) => ({
      title: item.title,
      elements: item.children,
      icon: item.icon,
      ...(item.url && {
        url: item.url
      })
    }));
  }

  const navGroups = menuItems.items.slice(0, lastItemIndex + 1).map((item, index) => {
    switch (item.type) {
      case 'group':
        if (item.url && item.id !== lastItemId) {
          return (
            <List key={item.id} sx={{ zIndex: 0, ...(isHorizontal && { mt: 0.5 }) }}>
              {!isHorizontal && index !== 0 && <Divider sx={{ my: 0.5, display: 'none' }} />}
              <NavItem
                item={item}
                level={1}
                isParents
                setSelectedID={setSelectedID}
                selectedID={selectedID}
                selectedLevel={selectedLevel}
              />
            </List>
          );
        }

        return (
          <NavGroup
            key={item.id}
            setSelectedID={setSelectedID}
            setSelectedItems={setSelectedItems}
            setSelectedLevel={setSelectedLevel}
            selectedLevel={selectedLevel}
            selectedID={selectedID}
            selectedItems={selectedItems}
            lastItem={lastItem}
            remItems={remItems}
            lastItemId={lastItemId}
            item={item}
          />
        );
      default:
        return (
          <Typography key={item.id} variant="h6" color="error" align="center">
            Fix - Navigation Group
          </Typography>
        );
    }
  });

  return (
    <Box
      sx={{
        pt: drawerOpen ? (isHorizontal ? 0 : 2) : 0,
        ...(!isHorizontal && { '& > ul:first-of-type': { mt: 0 } }),
        display: isHorizontal ? { xs: 'block', lg: 'flex' } : 'block'
      }}
    >
      {navGroups}
    </Box>
  );
}
